<template>
	<v-dropdown
		:label="trigger_label"
		:full_label="label"
		:mobile_label="mobile_label"
		:has_value="radio_value !== null"
	>
		<div class="pill-select">
			<button type="button" :class="{ btn: true, active: is_annual }" @click="set_period(`yr`)">Annual</button>

			<button type="button" :class="{ btn: true, active: !is_annual }" @click="set_period(`hr`)">Hourly</button>
		</div>

		<fieldset>
			<legend class="screen-reader-text">
				{{ label }}
			</legend>

			<label v-for="option in options" :key="option.value" class="radio">
				<input v-model.number="radio_value" type="radio" :value="option.value" @change="emit(`change`)" />

				<span>{{ option.label }}</span>
			</label>
		</fieldset>
	</v-dropdown>
</template>

<style lang="scss" scoped>
@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

.pill-select {
	@include pill-select;
	margin: 0 1em 0.5em;
}

fieldset {
	@include filter-option-list;
}
</style>

<script setup>
import { computed } from 'vue';

import { use_salary_filter } from './_use-salary-filter.js';
import VDropdown from './_v-dropdown.vue';

const props = defineProps({
	label: {
		type: String,
		required: false,
		default: `Salary`,
	},
	mobile_label: {
		type: String,
		required: false,
		default: null,
	},
});

const emit = defineEmits([`change`]);

const salary_period = defineModel(`salary_period`, {
	type: String,
	default: ``,
});

const require_salary = defineModel(`require_salary`, {
	type: String,
	default: ``,
});

const salary_min = defineModel(`salary_min`, {
	type: Number,
	default: null,
});

const { is_annual, options, radio_value, set_period } = use_salary_filter(
	salary_period,
	require_salary,
	salary_min,
	emit,
);

const trigger_label = computed(() => {
	for (const option of options.value) {
		if (option.value !== radio_value.value) {
			continue;
		}

		return option.value === null ? props.label : option.label;
	}

	return props.label;
});
</script>
